// Search Ideas
import { html } from "htm/preact";
import algoliasearch from "algoliasearch/lite";
import {
  IDEAS_SEARCH,
  ALGOLIA_APPLICATION_ID,
  ALGOLIA_API_KEY,
  ALGOLIA_INDEX_NAME,
} from "./env";
import { autocomplete, getAlgoliaResults } from "@algolia/autocomplete-js";
import "@algolia/autocomplete-theme-classic";
import "../css/search.css";
const searchClient = algoliasearch(ALGOLIA_APPLICATION_ID, ALGOLIA_API_KEY);

if (IDEAS_SEARCH == "show") {
  autocomplete({
    debug: "true",
    container: "#autocomplete",
    placeholder: "Search ideas...",
    detachedMediaQuery: "none",
    getSources({ query }) {
      return [
        {
          sourceId: "products",
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: ALGOLIA_INDEX_NAME,
                  query,
                  params: {
                    hitsPerPage: 9,
                    attributesToSnippet: ["name:10", "description:35"],
                    snippetEllipsisText: "…",
                  },
                },
              ],
            });
          },
          templates: {
            item({ item, createElement, Fragment }) {
              return html`<div><a href="${item.url}">${item.title}</a></div>`;
            },
            noResults() {
              return "There are no good matches for that search";
            },
          },
        },
      ];
    },
  });
}
